import { Deposit, DepositValueType } from '@urbanx/agx.campaigns.client';
import { ErrorState } from 'types/Payable';

export interface ContractDepositErrorState {
  initial: ErrorState;
  balance: ErrorState;
}

export interface ContractDepositModel {
  initialDeposit: Deposit;
  balanceDeposit: Deposit;
}

export const DepositOptions = [
  { label: DepositValueType.Dollar, value: DepositValueType.Dollar },
  { label: DepositValueType.Percentage, value: DepositValueType.Percentage },
];

export enum DepositRadioOptionType {
  TenPercentage = '10',
  FivePercentage = '5',
}
